import React from 'react';

const VideoDetail = ({ video }) => {
	if (!video) {
		return <div className="col-md-8">Loading...</div>;
	}

	const url = `https://www.youtube.com/embed/${video.id
		.videoId}?rel=0&autoplay=1`;

	return (
		<div className="video-detail col-lg-8">
			<div className="embed-responsive embed-responsive-16by9 shadowed">
				<iframe
					className="embed-responsive-item"
					src={url}
					title="main-video"
					frameborder="0"
					allowfullscreen="1"
				/>
			</div>
			<div className="details shadowed">
				<div className="video-title">
					{video.snippet.title}
				</div>
				<hr />
				<div className="video-description">
					{video.snippet.description}
				</div>
			</div>
		</div>
	);
};

export default VideoDetail;



// WEBPACK FOOTER //
// ./src/components/VideoDetail.js